// extracted by css-extract-rspack-plugin
export default {"CardBaseWithSash":"card-base-with-sash-module__CardBaseWithSash__thyVxdp"};